import React, { Component } from 'react';
import TravelVendorExclusionPage from './travel-vendor-exclusion-html';
class TravelVendorExclusion extends Component {
    constructor(props) {
        super(props)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    render() {
        return (
            <div>
                <TravelVendorExclusionPage
                />
            </div>
        )
    }
}
export default TravelVendorExclusion;